export const leaderboard: Record<string, string> = {
  // Header
  'LIVE · BETA': 'UŽIVO · BETA',
  'SIMULATED': 'SIMULIRANO',
  'Real connected accounts (read-only), ranked by verified score — beta': 'Pravi povezani nalozi (samo za čitanje), rangirani po verifikovanom skoru — beta',
  'Ranked by STM score from a $10k simulated account — not real money': 'Rangirano po STM skoru sa simuliranog naloga od $10k — bez pravog novca',
  'How scoring works': 'Kako funkcioniše bodovanje',

  // Scoring explainer modal
  'How the STM Score works': 'Kako funkcioniše STM skor',
  'Your': 'Tvoj',
  'STM Score (0–100)': 'STM skor (0–100)',
  'measures trading skill on a': 'meri trejding veštinu na',
  'simulated $10,000 account — not real money': 'simuliranom nalogu od $10.000 — bez pravog novca',
  ". It rewards a consistent, risk-controlled edge, and it's built so it can't be faked with luck or big gambles.": '. Nagrađuje konzistentnu prednost sa kontrolisanim rizikom i napravljen je tako da ne može da se lažira srećom ili velikim kockanjem.',
  'Your score goes up when you:': 'Tvoj skor raste kada:',
  'Make money consistently across many trades — a real, proven edge, not one lucky win': 'Zarađuješ konzistentno kroz mnogo trejdova — stvarna, dokazana prednost, a ne jedan srećan dobitak',
  'Keep winners bigger than losers (profit factor above 1)': 'Držiš dobitke veće od gubitaka (profit factor iznad 1)',
  'Grow smoothly, with small drawdowns': 'Rasteš ravnomerno, sa malim drawdown-ima',
  'Risk a small, steady amount per trade (around 1%, and never more than a few %)': 'Rizikuješ mali, stabilan iznos po trejdu (oko 1%, nikad više od nekoliko %)',
  'Your score stays low — or 0 — when you:': 'Tvoj skor ostaje nizak — ili 0 — kada:',
  'Have too few trades: the score only reaches full strength after about': 'Imaš premalo trejdova: skor dostiže punu snagu tek posle oko',
  '50 trades over ~8 weeks': '50 trejdova tokom ~8 nedelja',
  'Take oversized risk or run big drawdowns': 'Preuzimaš preveliki rizik ili imaš velike drawdown-e',
  'Blow up the account (score resets to 0)': 'Uništiš nalog (skor se resetuje na 0)',
  'To qualify for the ranked Top you need:': 'Za kvalifikaciju u rangirani Top potrebno je:',
  '30+ settled trades over 6+ weeks, a proven positive edge, profit factor ≥ 1.2, max risk ≤ 5% per trade, drawdown under 40%, and no blow-ups.': '30+ zatvorenih trejdova tokom 6+ nedelja, dokazana pozitivna prednost, profit factor ≥ 1.2, maksimalan rizik ≤ 5% po trejdu, drawdown ispod 40% i nijedan uništen nalog.',
  'Tiers:': 'Nivoi:',
  'Rising → Verified → Elite, as your track record gets longer and cleaner.': 'Rising → Verified → Elite, kako tvoj učinak postaje duži i čistiji.',
  'Other tabs rank by a single stat (best win rate, most trades, most followed, most consistent, top battles).': 'Ostale kartice rangiraju po jednoj statistici (najbolji win rate, najviše trejdova, najpraćeniji, najkonzistentniji, top bitke).',
  'ranks traders by real-account results instead of the simulated score.': 'rangira trejdere po rezultatima pravog naloga umesto po simuliranom skoru.',

  // Category tabs ('Live-Verified' already lives in profile.ts)
  'STM Score': 'STM skor',
  'Best Win Rate': 'Najbolji win rate',
  'Most Trades': 'Najviše trejdova',
  'Most Followed': 'Najpraćeniji',
  'Most Consistent': 'Najkonzistentniji',
  'Top Battlers': 'Top borci',
  'Top XP': 'Top XP',
  'Highest Level': 'Najviši nivo',
  'Longest Streak': 'Najduži niz',

  // Category descriptions
  'Ranked by simulated STM score': 'Rangirano po simuliranom STM skoru',
  'Real connected accounts (beta)': 'Pravi povezani nalozi (beta)',
  'Most accurate traders': 'Najprecizniji trejderi',
  'Most active traders': 'Najaktivniji trejderi',
  'Most popular traders': 'Najpopularniji trejderi',
  'Steady performers': 'Stabilan učinak',
  'Best battle win rate': 'Najbolji win rate u bitkama',
  'Most XP earned': 'Najviše zarađenog XP',
  'Highest trader level': 'Najviši nivo trejdera',
  'Longest active streak': 'Najduži aktivni niz',

  // Period filters
  '7 Days': '7 dana',
  '30 Days': '30 dana',
  '90 Days': '90 dana',
  'All Time': 'Sve vreme',

  // Badge tooltips + flags ('15+ closed trades…' already lives in profile.ts)
  '5–14 closed trades': '5–14 zatvorenih trejdova',
  '1–4 closed trades': '1–4 zatvorena trejda',
  'Over-risking (max risk > 5% or avg > 3%)': 'Prevelik rizik (maks. rizik > 5% ili prosek > 3%)',
  'Simulated account was wiped': 'Simulirani nalog je uništen',
  'HIGH RISK': 'VISOK RIZIK',
  'BLOWN': 'UNIŠTEN',

  // Table
  'Trader': 'Trejder',
  'Score': 'Skor',
  'Win %': 'Uspeh %',
  'Trades': 'Trejdovi',
  'Avg RR': 'Pros. RR',
  'Actions': 'Akcije',
  'LIVE': 'UŽIVO',
  'View profile': 'Pogledaj profil',
  'trades': 'trejdova',
  // 'win' already lives in channels.ts
  'followers': 'pratilaca',
  'consistency': 'konzistentnost',
  'STM score': 'STM skor',
  'verified · live': 'verifikovan · uživo',

  // Empty states + footer
  'No live-verified traders yet': 'Još nema live verifikovanih trejdera',
  'No traders yet': 'Još nema trejdera',
  'Connect a real account (Verify account) — pass the gates (≥30 trades, ≥6 weeks, DD≤40%, PF≥1.2) to appear here.': 'Poveži pravi nalog (Verifikuj nalog) — ispuni uslove (≥30 trejdova, ≥6 nedelja, DD≤40%, PF≥1.2) da se pojaviš ovde.',
  'Post a signal to show up on the leaderboard.': 'Objavi signal da se pojaviš na rang listi.',
  'Traders shown:': 'Prikazano trejdera:',
  'Not enough trades yet': 'Još nema dovoljno trejdova',
  'Ranking starts at': 'Rangiranje počinje od',
  'closed trades in the selected period.': 'zatvorenih trejdova u izabranom periodu.',
  'No one has enough closed trades in this period yet.': 'U ovom periodu još niko nema dovoljno zatvorenih trejdova.',
  'closed trades — traders who are close are listed below.': 'zatvorenih trejdova — trejderi koji su blizu navedeni su ispod.',
  'closed trades': 'zatvorenih trejdova',

  // Left sidebar (layout unifikacija)
  'Rankings': 'Rang lista',
  'Top this week': 'Top nedelje',
  'Signal Providers': 'Signal provajderi',
  'Verified Traders': 'Verifikovani',
  'HOW WE RANK': 'KAKO RANGIRAMO',
  'Rankings are calculated exclusively from verified trades: win rate, average R, and consistency. No self-reported results.':
    'Rang se računa isključivo iz verifikovanih trejdova: win rate, prosečan R i konzistentnost. Bez samoprijavljenih rezultata.',
};
